import { z } from "zod";

import { InsertTypeList } from "../dtos/onsite-edits";

export const FindReplaceSchema = z.object({
  id: z.string().uuid(),
  find: z.string().nullable(),
  title: z.string().nullish(),
  isRegex: z.boolean().default(false),
  replace: z.string().default(""),
  querySelectors: z.string().array().default([""]),
  skip: z.boolean().default(false),
  remove: z.boolean().default(false),
  groupId: z.string().optional(),
  isHtml: z.boolean().default(false),
  isImage: z.boolean().default(false),
  insertType: z.enum(InsertTypeList).nullable(),
  createdAtUrl: z.string().optional().nullable(),

  //   FE ONLY
  errors: z.array(z.string()).default([""]),
  isMinimized: z.boolean().default(false),
});
export type FindReplaceType = z.infer<typeof FindReplaceSchema>;

export const PostFindReplaceSchema = FindReplaceSchema.extend({
  testGroupId: z.string().uuid(),
  organizationId: z.string().uuid(),
  experimentId: z.string().uuid(),
});
export type PostFindReplaceType = z.infer<typeof PostFindReplaceSchema>;
